import { render, staticRenderFns } from "./apiproductchannelreport-add-or-update.vue?vue&type=template&id=09f979a8&"
import script from "./apiproductchannelreport-add-or-update.vue?vue&type=script&lang=js&"
export * from "./apiproductchannelreport-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports